import fillHtml from "../utils/fillHtml";

function handleBtnClick(e) {
    e.preventDefault();

    const CLASS_LOADING = "loading";

    const $btn = $(this);

    const isLoading = $btn.hasClass(CLASS_LOADING);
    const { link, type, target } = $btn.data();

    if (isLoading || !link) return;

    $btn.addClass(CLASS_LOADING);

    axios
        .get(link)
        .then((response) => {
            const $target = $("#" + target);

            // add html
            const htmlstring = response.data.data.reduce((result, item) => {
                return result + fillHtml(item, type);
            }, "");

            $(htmlstring).appendTo($target);

            // update button
            const link = response.data.links.next;
            $btn.data("link", link);
            if (!link) {
                $btn.hide();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            $btn.removeClass(CLASS_LOADING);
        });
}

$(function () {
    $(document).on("click", ".btn-more", handleBtnClick);
});
